import { MoveVerticesFeature } from '@kb3d/models/classes/features/move-vertices-feature';
import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer, SubmeshVertexDataMap } from './feature';
import {
    MoveVerticesDependencyData,
    MoveVerticesGeometryProcessor,
    MoveVerticesWorkerPayload,
} from './geometry-processor/move-vertices-geometry';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { Vector3 } from '@babylonjs/core/Maths';

export class MoveVerticesRenderer extends FeatureRenderer<MoveVerticesFeature> {
    modelToken = Token.MoveVerticesFeature;

    processor = new MoveVerticesGeometryProcessor(this.scene);

    async makeWorkerPayload(feature: MoveVerticesFeature, geometryData: SubmeshVertexDataMap) {
        const payload = await super.makeWorkerPayload(feature, geometryData);
        const pivot = feature._parent?.pivot || { x: 0, y: 0, z: 0 };
        const featureData: MoveVerticesWorkerPayload = {
            pivot: { x: pivot.x, y: pivot.y, z: pivot.z },
        };

        payload.featureData = featureData;

        return payload;
    }

    updateMeshGeometry(
        feature: MoveVerticesFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const meshDynamicId = feature._parent?._dynamicId || '';
        const pivot = feature._parent?.pivot.toVec3() || Vector3.Zero();
        const dependencyData: MoveVerticesDependencyData = {
            pivot,
        };
        return this.processor.updateMeshGeometry(feature, vertexData, vertexDataChanges, {
            meshDynamicId,
            data: dependencyData,
        });
    }

    update3dInternal() {}
}
